import React, { useContext } from 'react';

import { Result } from 'antd';
import { Context } from '../context';
import { translations } from '../helpers/i18n';

function Page404(props) {
  const { language } = useContext(Context);
  const t = translations[language] || translations.EN;

  return (
    <Result status="404" title="404" subTitle={t.home404Subtitle}/>
  );
}

export default Page404;